// Copyright © 2021 React Training LLC. All rights reserved.
import React from 'react';

function createClientRoute(entryRoute, Component) {
  return {
    caseSensitive: !!entryRoute.caseSensitive,
    element: /*#__PURE__*/React.createElement(Component, {
      id: entryRoute.id
    }),
    id: entryRoute.id,
    path: entryRoute.path
  };
}
function createClientRoutes(routeManifest, Component, parentId) {
  return Object.keys(routeManifest).filter(key => routeManifest[key].parentId === parentId).map(key => {
    let route = createClientRoute(routeManifest[key], Component);
    let children = createClientRoutes(routeManifest, Component, route.id);
    if (children.length > 0) route.children = children;
    return route;
  });
}

export { createClientRoute, createClientRoutes };
